<template>
  <div
    :class="classLabel"
    class="flex items-center gap-1 label-type-answer"
  >
    <aha-icon
      :name="icon"
      width="13"
      height="13"
      viewBox="0 0 18 18"
    >
    </aha-icon>
    <strong>{{ text }}</strong>
  </div>
</template>
<script>
const nameMaps = {
  1: 'Incorrect',
  2: 'Correct',
  3: 'Partially correct',
  4: 'Unattempted',
}

const classMap = {
  1: 'incorrect-label',
  2: 'correct-label',
  3: 'correct-label',
  4: 'unattempted-label',
}

const iconMap = {
  1: 'incorrect',
  2: 'correct',
  3: 'correct',
  4: 'warning',
}

export default {
  props: {
    typeAnswerCorrect: {
      type: Number,
      default: 1,
    },
  },
  computed: {
    classLabel() {
      return classMap[this.typeAnswerCorrect]
    },
    text() {
      return nameMaps[this.typeAnswerCorrect]
    },
    icon() {
      return iconMap[this.typeAnswerCorrect]
    },
  },
}
</script>

<style scoped>
  .label-type-answer {
    border-radius: 20px;
    padding : 4px 8px;
    border-width: 1px;
    border-style: solid;
  }
  .correct-label {
    @apply bg-green-10 text-green-50 border-green-50;
  }
  .incorrect-label {
    @apply bg-red-10 text-red-50 border-red-50;
  }

  .unattempted-label {
    @apply bg-primary-50 text-secondary-100 border-secondary-20;
  }
</style>
